import {gql, useMutation} from '@apollo/client'

const useAssignTagToStudent = (onCompleted = () => {}, onError = () => {}) => {
  return useMutation(
    gql`
      mutation SetTagToStudent($studentId: ID!, $tagId: ID!) {
        setTagToStudent(studentId: $studentId, tagId: $tagId)
      }
    `,
    {onCompleted, onError},
  )
}

export default useAssignTagToStudent